import { DescribeProperty } from '../../common';

export class RunProcessResponse {
  @DescribeProperty({
    description: 'The ID of created conversion',
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  id: string;
}
